import React from "react";
// import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import "antd/dist/reset.css";
import "../App.css";
import { useLocation } from "react-router-dom";

const AuthOffline = () => {
  const location = useLocation();
  const message = location?.state?.message;
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin
          style={{
            color: "white",
            fontSize: "30px",
          }}
          className="custom-spinner"
          tip={message}
          size="large"
        ></Spin>
      </div>
    </>
  );
};

export default AuthOffline;
